import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../editable-cell'

interface LacquersDmsProps {}

const LacquersDms: FC<LacquersDmsProps> = () => {
    const ctx = useContext(EditableCellCtx)
    return (
        <Form.Item name={'lacquersDms'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} />
        </Form.Item>
    )
}

export default LacquersDms
